import Vue from 'vue'

const RESOLVED_STATUSES = ['Succeeded', 'Failed']

export function isResolvedStatus(status) {
  return RESOLVED_STATUSES.includes(status)
}

export const state = () => ({
  quotes: []
})

export const mutations = {
  SET_QUOTES(state, payload) {
    state.quotes = payload
  },
  UPDATE_QUOTE(state, payload) {
    const quoteIndex = state.quotes
      .map((quote) => quote.uuid)
      .indexOf(payload.uuid)

    if (quoteIndex === -1) {
      state.quotes.push(payload)
      return
    }

    Vue.set(state.quotes, quoteIndex, payload)
  }
}

export const getters = {
  companies: (state) => {
    return state.quotes.reduce((accumulator, quote) => {
      const companyExistOnArray = accumulator.find(
        (company) => company.id === quote.provider.company.id
      )

      if (companyExistOnArray) {
        return accumulator
      }

      return accumulator.concat([quote.provider.company])
    }, [])
  },
  planTypes: (state) => {
    return state.quotes.reduce((accumulator, quote) => {
      const planTypeExistsOnArray = accumulator.find(
        (planType) => planType.id === quote.plan.type.id
      )

      if (planTypeExistsOnArray) {
        return accumulator
      }

      return accumulator.concat([quote.plan.type])
    }, [])
  },
  coverages: (state) => {
    return state.quotes.reduce((accumulator, quote) => {
      quote.coverages.forEach((coverage) => {
        const coverageName = coverage.name

        if (accumulator.includes(coverageName)) {
          return accumulator
        }

        accumulator.push(coverageName)
      })

      return accumulator
    }, [])
  },
  maximiumPremiums: (state) => {
    const premiums = {
      annualPremium: 0,
      semiannualPremium: 0,
      quarterlyPremium: 0,
      monthlyPremium: 0
    }

    state.quotes.forEach((quote) => {
      Object.keys(premiums).forEach((key) => {
        if (quote[key] === null || quote[key] === undefined) {
          return
        }

        if (premiums[key] > quote[key]) {
          return
        }

        premiums[key] = quote[key]
      })
    })

    return premiums
  }
}

export const actions = {
  async getPlan({ commit }, { id }) {
    const response = await this.$axios.get(`health-insurance/quotes/${id}`, {
      baseURL: process.env.API_V2_BASE_URL
    })

    commit('SET_QUOTES', response.data.quotes)
  }
}
